import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';
import ABanner from './components/Banner';
import BSlider from './components/Slider';
import CSection3 from './components/Section3';
import DSection4 from './components/Section4';
import EOther from './components/EOther';
import ScrollMagicFn from '@/utils/ScrollMagic';

export default function XstreamH5() {
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    return (
        <div className={`${css.xstream_h5} xstream_h5`}>
            <div className="containerBox">
                <div className="bgBox">
                    <ABanner />
                    <BSlider />
                </div>
            </div>
            <CSection3 />
            <DSection4 />
            <EOther />
        </div>
    );
}
